/* language */
const langObj = {
  ko: {
    vali_1: '최소',
    vali_2: '이상의 값만 가능합니다.',
    vali_3: '최대',
    vali_4: '이하의 값만 가능합니다.',
    vali_5: '값을 입력하세요.',
    vali_6: '숫자만 가능합니다.',
    vali_7: '영문만 가능합니다.',
    vali_8: '공백은 입력 할 수 없습니다.',
    vali_9: '올바르지 않은 이메일 양식입니다.',
    vali_10: '사용불가 문자 포함',
    vali_11: '날짜를 다시 선택하세요.',
    vali_12: '과거는 선택 할 수 없습니다.',
    vali_13: '대상 태그를 선택하세요.',
    vali_14: '값이 없습니다.',
    vali_15: '날짜를 선택하세요.',
    vali_16: '훈련 양식을 선택하세요.',
    vali_17: '압축 파일 종류를 선택하세요.',
    vali_18: '압축 파일 종류를 선택하세요.',
    vali_19: '수량은 1 이상입니다.',
    vali_20: '이미 사용중인 훈련명입니다.',
    vali_21: '이미 등록된 태그명입니다.',
    vali_22: '이미 등록된 이메일입니다.',
    vali_23: '알파벳을 포함하세요.',
    vali_24: '숫자를 포함하세요.',
    vali_25: '특수문자를 포함하세요.',
    vali_27: '자리 이상 입력하세요.',
    vali_28: '대문자를 포함하세요.',
    vali_29: '동일한 문자 ',
    vali_30: '연속된 문자 ',
    vali_31: '개 이상 제한',
    vali_32: '아이디랑 동일 문자 제한',
    vali_33: '가능한 확장자',
    vali_34: '파일명 마지막에 숫자를 입력 할 수 없습니다.',
    vali_35: '올바른 url이 아닙니다.',
    vali_36: '공백은 연속으로 입력 할 수 없습니다.',
    vali_37: '공백을 맨앞에 입력 할 수 없습니다.',
    vali_38: '공백을 맨뒤에 입력 할 수 없습니다.',
    vali_39: '최소값',
    vali_40: '최대값',
    vali_41: '최소 길이',
    vali_42: '최대 길이',
    vali_43: '입력 허용 범위',
    vali_44: '자',
    vali_45: '명 이하만 등록 가능합니다.',
    vali_46: '훈련 템플릿을 선택하세요.',
    vali_47: '접근 허용 IP 양식이 올바르지 않습니다. (Array형태가 아닌 값이 있음)',
    vali_48: '접근 허용 IP 양식이 올바르지 않습니다. (JSON 형태가 이상함)',
    vali_49: '이미 사용중인 교육명입니다.',
    vali_50: '교육 컨텐츠를 선택하세요.',
    vali_51: ' ',
    vali_52: ' ',
    vali_53: ' '
  },
  ja: {
    vali_1: '最低',
    vali_2: '以上の値のみ可能です。',
    vali_3: '最大',
    vali_4: '以下の値のみ可能です。',
    vali_5: '値を入力してください。',
    vali_6: '数字のみ入力できます。',
    vali_7: '英字のみ入力できます。',
    vali_8: 'スペースを空ける必要はありません。',
    vali_9: 'メールアドレスの形式が正しくありません。',
    vali_10: '使用できない文字が含まれています',
    vali_11: '日付を改めて選択して下さい。',
    vali_12: '過去は選択できません。',
    vali_13: '対象者タグを選択してください。',
    vali_14: '値がありません。',
    vali_15: '日付を選択して下さい。',
    vali_16: '訓練様式を選択して下さい。',
    vali_17: '圧縮ファイルの種類を選択して下さい。',
    vali_18: '圧縮ファイルの種類を選択して下さい。',
    vali_19: '数量は1以上です。',
    vali_20: 'すでに使用中の訓練名です。',
    vali_21: 'すでに登録されているタグ名です。',
    vali_22: 'すでに登録されているメールアドレスです。',
    vali_23: '小文字 a～z (ローマ字)を含む必要があります。',
    vali_24: '数字を含む必要があります。',
    vali_25: '特殊文字を含む必要があります。',
    vali_27: '文字以上で設定してください。',
    vali_28: '大文字 A～Z (ローマ字)を含む必要があります。',
    vali_29: '同じ文字',
    vali_30: '連続した文字',
    vali_31: '以上の制限',
    vali_32: 'IDと同じ文字制限',
    vali_33: '可能な拡張子',
    vali_34: 'ファイル名の最後に数字を入力することはできません',
    vali_35: 'ドメインが正しくありません。',
    vali_36: '連続したスペースは入力できません。',
    vali_37: '開始時にスペースを入力することはできません',
    vali_38: '最後にスペースを入力することはできません',
    vali_39: '最小値',
    vali_40: '最大値',
    vali_41: '最小の長さ',
    vali_42: '最大の長さ',
    vali_43: '入力許容範囲',
    vali_44: '字',
    vali_45: '名以下のみ登録可能です。',
    vali_46: '訓練テンプレートを選択してください。',
    vali_47: 'アクセスを許可したIPアドレスの形式が正しくありません(配列型ではない値がある)',
    vali_48: 'アクセスを許可したIPアドレスの形式が正しくありません(JSON形式が正しくありません)',
    vali_49: '既に使用中の教育名です。',
    vali_50: '教育コンテンツを選択してください',
    vali_51: 'same characters are not required',
    vali_52: 'consecutive characters are not required',
    vali_53: 'Up to'
  },
  en: {
    vali_1: 'Only more than',
    vali_2: 'values are possible.',
    vali_3: 'Up to',
    vali_4: 'values are possible.',
    vali_5: 'Please enter a value.',
    vali_6: 'only numbers are allowed.',
    vali_7: 'only in English.',
    vali_8: 'No spaces are allowed.',
    vali_9: 'Invalid email form',
    vali_10: 'Include unacceptable characters.',
    vali_11: 'Please select a date again.',
    vali_12: 'You cannot choose the past.',
    vali_13: 'Please select a tag for trainee.',
    vali_14: 'No value found',
    vali_15: 'Please select a date.',
    vali_16: 'Please select a template.',
    vali_17: 'Please select the type of compressed type.',
    vali_18: 'Please select a compressed file type.',
    vali_19: 'Quantity is more than 1.',
    vali_20: 'This training name is already in use.',
    vali_21: 'This tag name is already in use.',
    vali_22: 'This email address is already in use.',
    vali_23: 'Please include the alphabet.',
    vali_24: 'Please include the numbers.',
    vali_25: 'Please include special characters.',
    vali_27: 'is required',
    vali_28: 'Please include capital letters.',
    vali_29: ' ',
    vali_30: ' ',
    vali_31: ' ',
    vali_32: 'The same character as the ID cannot be used for the password.',
    vali_33: 'Possible extensions',
    vali_34: 'You cannot enter a number at the end of file name.',
    vali_35: 'Not a valid URL',
    vali_36: 'No spaces allowed',
    vali_37: 'You cannot enter a space at the beginning.',
    vali_38: 'You cannot type a space at the end.',
    vali_39: 'Minimum value',
    vali_40: 'Maximum value',
    vali_41: 'Minimum length',
    vali_42: 'Maximum length',
    vali_43: 'Enter allowed range',
    vali_44: 'letter',
    vali_45: ' ',
    vali_46: 'Select the training template',
    vali_47: 'Invalid access permission IP (There is a value that is not an Array type)',
    vali_48: 'Invalid access permission IP (Strange JSON type)',
    vali_49: 'This name is already in use',
    vali_50: 'Select the contents',
    vali_51: 'same characters are not required',
    vali_52: 'consecutive characters are not required',
    vali_53: 'Up to'
  }
};
let language = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
const languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];
const lang = langObj[!!localStorage.getItem('language') ? localStorage.getItem('language') : languageWithoutRegionCode];


/* regExp */
export const RegExpEmail = new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i);

/* Function */
const _range = (value, start, end, hintMsg) => {
  hintMsg =
    typeof hintMsg === 'undefined'
      ? lang.vali_43 + ': [ ' + (start > 0 ? start + '~' : '') + end + lang.vali_44 + ' ]'
      : hintMsg;
  return String(value).length < start || String(value).length > end ? hintMsg : undefined;
};

const _required = (value, hintMsg) => {
  hintMsg = typeof hintMsg === 'undefined' ? lang.vali_5 : hintMsg;
  return value === undefined || value === null || value === '' ? hintMsg : undefined;
};

/* validation */
export const range15 = value => _range(value, 0, 15);
export const range50 = value => _range(value, 0, 50);
export const rangeID = value => _range(value, 5, 50);
export const range100 = value => _range(value, 0, 100);
export const range200 = value => _range(value, 0, 200);
export const range320 = value => _range(value, 0, 320);
export const range5000 = value => _range(value, 0, 5000);

export const required = value => _required(value, lang.vali_14);
export const number = value => (value && isNaN(Number(value)) ? lang.vali_6 : undefined);

export const email = value => {
  if (!!range320(value)) {
    return range320(value);
  }

  return value && !RegExpEmail.test(value) ? lang.vali_9 : undefined;
};


